
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'order',
components: {
cmBlank,cmLoadmore,Datetime
},
data () {
return {
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
hasNext:0,
pageFlag:2,
lastId:0,
list:[],
phone:'',
datetimeStatus:false,
startDate:'',
endDate:'',
minHour:8,
maxHour:18,
days:30,
editTimeIndex:'',
}
},
mounted(){
if(!this.$func.getLocal('token')){
window.location.href = "/";
return false;
}
this.setDate();

},
methods:{
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
hour: nowDate.getHours(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
this.minHour = date.hour+1;
if(nowDate.getHours() >= this.maxHour-1){
var date = new Date(this.startDate);
date.setDate(date.getDate() + 1);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
}
var date = new Date(this.startDate);
date.setDate(date.getDate() + this.days);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
datetimeShow(){
this.datetimeStatus = true;
},
datetimeChange(val){

this.list[this.editTimeIndex].home_time = val;
this.$api.editHomeTime({id:this.list[this.editTimeIndex].id,home_time:val}).then((res)=>{
if(res){
this.$func.showToast('已修改');
}
})
this.datetimeStatus = false;
},
editHomeTime(index){
this.editTimeIndex = index;
},
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
getList(){
this.$api.getOrderLists({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,status:2}).then((res)=>{
if(res){
console.log(res);
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/waitCollect.vue